import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SortingDirection } from './models/SortingDirection';
import SortingItemDescriptor from './models/SortingItemDescriptor';
import styles from './sortingMenuItem.module.scss';

type Props = {
  item: SortingItemDescriptor;
  onSortingClick: (name: string, direction: SortingDirection) => void;
  sortingMenuRef: React.MutableRefObject<any>;
}

const SortingMenuItem = ({ item, onSortingClick, sortingMenuRef }: Props) => {
  // translations
  const tLabels = useTranslation(item.translationPath ?? "").t;

  // helpers
  const getActiveItemClass = (descriptor: SortingItemDescriptor, direction: SortingDirection) => { 
    if (descriptor.active && descriptor.direction === direction) {
      return " text-primary";
    }

    return "";
  }
  
  const sortingArrowClickHandler = (direction: SortingDirection) => { 
    onSortingClick(item.name, direction);
    sortingMenuRef.current.click();
  }

  const getTranslatedLabel = () => {
    if (item.translationPath) {
      return tLabels(item.label);
    }

    return item.label;
  }

  // render
  return (
    <div
      className='py-1 px-3'
      key={item.name}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div>{getTranslatedLabel()}</div> 
        <div>
          <div className="d-flex ml-4">
            <span 
              onClick={() => sortingArrowClickHandler("ASC")}
              className={`${styles.sortingArrow}${getActiveItemClass(item, "ASC")}`}
              role="button"
            >
              <FontAwesomeIcon icon="long-arrow-alt-up" />
            </span>
            <span 
              onClick={() => sortingArrowClickHandler("DESC")}
              className={`ml-1 ${styles.sortingArrow}${getActiveItemClass(item, "DESC")}`}
              role="button"
            >
              <FontAwesomeIcon icon="long-arrow-alt-down" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SortingMenuItem;